import React from "react";
import Form from "../../common/forms/Form";
import RegistHeader from "./RegistHeader";
import styles from "./p-register.module.scss";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  submit_handler: () => void;
  backward_handler: () => void;
};

const RegistEmailForm: React.FC<Props> = ({
  submit_handler,
  backward_handler,
}) => {
  return (
    <div className={styles["p-register__box"]}>
      <RegistHeader
        showLogo={false}
        title={"利用規約への同意"}
        message={"利用規約とプライバシーポリシーに\n同意しますか？"}
      />
      <div className={styles["p-register__form"]}>
        <SonicLink
          to="/info/terms-members"
          className={styles["p-register__link"]}
          newTab={true}
        >
          利用規約
        </SonicLink>
        <SonicLink
          to="/info/privacy"
          className={styles["p-register__link"]}
          newTab={true}
        >
          プライバシーポリシー
        </SonicLink>

        <Form
          handler={submit_handler}
          button_id="next_button"
          button_text="同意して登録する"
          button_class={`${styles["p-register__form__button"]} ${styles["active"]}`}
        ></Form>
        <button
          type="button"
          className={styles["p-register__form__button"]}
          onClick={backward_handler}
        >
          戻る
        </button>
      </div>
    </div>
  );
};

export default RegistEmailForm;
